import React from "react";
import { Col, Row } from "react-bootstrap";
import { 
  SiDart, 
  SiKotlin, 
  SiCplusplus, 
  SiPostgresql, 
  SiMysql, 
  SiSqlite, 
  SiGit, 
  SiMui, 
  SiPostman, 
  SiFirebase 
} from "react-icons/si";
import { DiJava } from "react-icons/di";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiDart fontSize={"24px"} />
        <div className="tech-icons-text">Dart</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava fontSize={"24px"} />
        <div className="tech-icons-text">Java</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKotlin fontSize={"24px"} />
        <div className="tech-icons-text">Kotlin</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCplusplus fontSize={"24px"} />
        <div className="tech-icons-text">C/C++</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql fontSize={"24px"} />
        <div className="tech-icons-text">PostgreSQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql fontSize={"24px"} />
        <div className="tech-icons-text">MySQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSqlite fontSize={"24px"} />
        <div className="tech-icons-text">SQLite</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGit fontSize={"24px"} />
        <div className="tech-icons-text">Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMui fontSize={"24px"} />
        <div className="tech-icons-text">Material UI</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman fontSize={"24px"} />
        <div className="tech-icons-text">Postman</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase fontSize={"24px"} />
        <div className="tech-icons-text">Firebase</div>
      </Col>
    </Row>
  );
}

export default Techstack;
